const FILTER_PARAMS = ['search', 'teams', 'users', 'categories', 'tools', 'certificationStatuses', 'playlists', 'contentIds', 'contentTypes', 'dueDate', 'completedDate', 'assignedByMe'];
const PAGINATION_PARAMS = ['page', 'pageSize'];
const SORT_PARAMS = ['sortBy', 'sortOrder'];
export const TABLE_STATE_PARAMS = [...FILTER_PARAMS, ...PAGINATION_PARAMS, ...SORT_PARAMS];